import React from 'react';
import { Col } from 'react-bootstrap';
import Skeleton from '../../components/common/skeleton';

const DocumentBoxSkeleton = () => {
  return (
    <>
      <Col className="box-margin" md={4}>
        <div className="documents-box">
          <div className="box-header">
            <Skeleton count={1} height={25} width={150} />
            <div className="d-flex">
              <span className="icon-space download-doc">
                <Skeleton count={1} height={25} width={25} />
              </span>
              <span className="edit-icon">
                <Skeleton count={1} height={25} width={25} />
              </span>
            </div>
          </div>
          <div className="box-body">
            <Skeleton count={1} height={25} width={200} />
            <Skeleton count={1} height={25} width={300} />
            <div className="document-description">
              <Skeleton count={1} height={25} width={350} />
            </div>
            <div className="upload-div">
              <Skeleton count={1} height={25} width={150} />
            </div>
          </div>
        </div>
      </Col>
    </>
  );
};

export default DocumentBoxSkeleton;
